import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addFile,
  addFolder,
  addMediaConfig,
  getFilesList,
  getFolderList,
  getFolderParentList,
  getMediaConfig,
  getSingleFolderListData,
  updateFile,
  updateFolder,
  updateMediaConfig,
} from "./MaterialRepo";
import { showToast } from "../../../utils/toastUtils";

export const useFolderList = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["MATERIAL_FOLDER_LIST", params],
    queryFn: () => getFolderList(params),
    enabled: enable,
    retry: false,
  });
};

// getFolderParentList

export const useFolderParentData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["MATERIAL_FOLDER_LIST"],
    queryFn: getFolderParentList,
    enabled: enable,
    retry: false,
  });
};

// addFolder
export const useAddFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body?: any }) => addFolder(body),
    onSuccess: (data) => {
      showToast.success("Add Folder Successfully!");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_FOLDER_LIST"] });
      // queryClient.invalidateQueries({
      //   queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      // });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Add Folder!");
    },
  });
};

// getSingleFolderListData
export const useSingleFolderListData = ({
  enable = false,
  id,
}: { enable?: boolean; id?: string | number } = {}) => {
  return useQuery({
    queryKey: ["MATERIAL_FOLDER_SINGLE_LIST", id],
    queryFn: () => getSingleFolderListData(id),
    enabled: enable,
    retry: false,
  });
};

// UPDATE_FOLDER
export const useUpdateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: string | number; body?: any }) =>
      updateFolder(id, body),
    onSuccess: (data: any) => {
      console.log("🚀 ~ useMaterial.tsx:84 ~ useUpdateFolder ~ data:", data);

      showToast.success("Update Folder Successfully!");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_FOLDER_LIST"] });
      queryClient.invalidateQueries({
        queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Update Folder!");
    },
  });
};

// getFilesList
export const useFilesList = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["MATERIAL_FILES_LISTS", params],
    queryFn: () => getFilesList(params),
    enabled: enable,
    retry: false,
  });
};

// addFile
export const useAddFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body?: any }) => addFile(body),
    onSuccess: (data) => {
      showToast.success("Add Files Successfully!");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_FILES_LISTS"] });
      // queryClient.invalidateQueries({
      //   queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      // });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Add File!");
    },
  });
};

export const useUpdateFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateFile(id, body),
    onSuccess: (data) => {
      showToast.success("Update file successfully");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_FILES_LISTS"] });
      // queryClient.invalidateQueries({
      //   queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      // });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Update File!");
    },
  });
};

// getMediaConfig
export const useMediaConfig = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["MATERIAL_MEDIA_CONFIG", params],
    queryFn: () => getMediaConfig(params),
    enabled: enable,
    retry: false,
  });
};

// addMediaConfig
export const useAddMediaConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body?: any }) => addMediaConfig(body),
    onSuccess: (data) => {
      showToast.success("Add Media Config Successfully!");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_MEDIA_CONFIG"] });
      // queryClient.invalidateQueries({
      //   queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      // });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Add Media Config File!");
    },
  });
};

export const useUpdateMediaConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body?: any }) => updateMediaConfig(body),
    onSuccess: (data) => {
      showToast.success("Update Media Config Successfully!");
      queryClient.invalidateQueries({ queryKey: ["MATERIAL_MEDIA_CONFIG"] });
      // queryClient.invalidateQueries({
      //   queryKey: ["MATERIAL_FOLDER_SINGLE_LIST"],
      // });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Update Media Config File!");
    },
  });
};
